import { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import StockSummary from "./StockSummary";
import StockTable from "./StockTable";
import CreateStock from "./CreateStock";
import UpdateStock from "./UpdateStock";
import DeleteStock from "./DeleteStock";

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


export default function Stock() {
  const [openCreateStock, setOpenCreateStock] = useState(false);
  const [openUpdateStock, setOpenUpdateStock] = useState(false);
  const [openDeleteStock, setOpenDeleteStock] = useState(false);

  return (
    <Box 
      sx={{
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
      {/* Info de stock: total, bajo stock, sin stock*/}
      <Box
        sx={{
          height: "15vh",
        }}
      >
        <StockSummary />
      </Box>

      {/* Botones de acción: crear, actualizar, eliminar */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          height: "8vh",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography variant="h4">Stock de Productos</Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PlaylistAddIcon />}
            onClick={() => setOpenCreateStock(true)}
          >
            Agregar Stock
          </Button>
          <CreateStock
            open={openCreateStock}
            onClose={() => {
              setOpenCreateStock(false);
            }}
          />
          
          <Button
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            onClick={() => setOpenUpdateStock(true)}
          >
            Registrar Entrada
          </Button>
          <UpdateStock
            open={openUpdateStock}
            close={() => setOpenUpdateStock(false)}
          />

          <Button
            variant="contained"
            color="error"
            startIcon={<DeleteIcon />}
            onClick={() => setOpenDeleteStock(true)}
          >
            Eliminar de Stock
          </Button>
          <DeleteStock
            open={openDeleteStock}
            onClose={() => setOpenDeleteStock(false)}
          />
        </Box>

      </Box>

      {/* Tabla de productos en stock */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "54vh",
          mt: 2,
        }}
      >
        <StockTable />
      </Box>
    </ Box>
  );
}
